import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { getRolesAndPermission } from '../../service/helper.service';
import { SharedService } from '../../../../../data/src/lib/services/shared/shared.service';

@Injectable({
  providedIn: 'root',
})
export class RolePermissionGuard implements CanActivate {
  constructor(
    private router: Router,
    private cookieService: CookieService,
    private sharedService: SharedService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // Check if user is logged in first
    const token = this.cookieService.get('token');
    if (!token) {
      this.router.navigate(['/login']);
      return false;
    }

    // Get user role
    const userRole = this.cookieService.get('u_type');
    const decodedUserRole = this.sharedService.decodeURIComponentParam(userRole)?.toLowerCase();

    // Super admin has access to everything
    if (decodedUserRole === 'super admin') {
      return true;
    }

    // Get required permissions from route data
    const requiredModule = route.data['requiredModule'];
    const requiredParentModule = route.data['requiredParentModule'];

    // If no specific permissions required, allow access (backward compatibility)
    if (!requiredModule || !requiredParentModule) {
      return true;
    }

    // Check if user has the required permissions
    const userPermissions = getRolesAndPermission(requiredModule, requiredParentModule);

    // If user has permissions and view access is granted, allow access
    if (userPermissions && userPermissions.isView) {
      return true;
    }

    // If no permissions found, redirect to unauthorized page
    this.router.navigate(['/forbidden']);
    return false;
  }
}
